<template>
  <div class="content1">
    <div class="pc" v-if="mobileFlag">
      <!-- 查询条件区域 -->
      <div class="filter-bar">
        <el-form :inline="true" :model="query" size="medium" label-width="100px">
          <el-form-item label="开始日期">
            <el-date-picker
              v-model="query.startDate"
              type="date"
              placeholder="选择日期"
              clearable
              @change="queryData"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker
              v-model="query.endDate"
              type="date"
              placeholder="选择日期"
              clearable
              @change="queryData"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="积分来源">
            <el-select
              v-model="query.sourceTypeId"
              placeholder="请选择积分来源"
              clearable
            >
              <el-option
                v-for="item in optionsSourceType"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="部门">
            <el-cascader
              v-model="query.orgId"
              :options="optionsDepartment"
              :props="defaultProps1"
              clearable
              filterable
              placeholder="请选择部门"
            ></el-cascader>
          </el-form-item>
          <!-- <el-form-item label="职级">
      <el-select
        v-model="query.empRank"
        placeholder="请选择职级"
        clearable
        filterable
      >
        <el-option
          v-for="item in optionsRank"
          :key="item.id"
          :label="item.title"
          :value="item.id"
        />
      </el-select>
    </el-form-item> -->
          <el-form-item label="手机号">
            <el-input
              v-model="query.phone"
              placeholder="请输入手机号"
              clearable
              @change="queryData"
            ></el-input>
          </el-form-item>
          <el-form-item label="工号">
            <el-input
              v-model="query.empNo"
              placeholder="请输入工号"
              clearable
              @change="queryData"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button  type="primary"  @click="queryData">查询</el-button>
            <el-button  @click="exportRecord">导出</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格区域 -->
      <div class="table_con">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          v-loading="tableLoading"
          :height="windowHeight"
        >
          <el-table-column
            prop="userName"
            label="姓名"
            align="center"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="userId"
            label="工号"
            align="center"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="createdAt"
            label="时间"
            align="center"
            min-width="160"
          >
            <template slot-scope="scope">
              {{
                scope.row.createdAt
                  ? $moment(scope.row.createdAt).format("YYYY-MM-DD HH:mm:ss")
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="totalPoints"
            label="累计积分"
            align="center"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
          prop="availablePoints"
          label="未同步积分"
          align="center"
          width="120"
        />
          <el-table-column
            prop="points"
            label="积分变动"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span
                :style="{ color: scope.row.points > 0 ? '#F56C6C' : '#67C23A' }"
              >
                {{
                  scope.row.points > 0
                    ? "+" + scope.row.points
                    : scope.row.points
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="description"
            label="积分来源记录"
            align="center"
            min-width="200"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            align="center"
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="createBy"
            label="操作人"
            align="center"
            min-width="100"
          >
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination_con">
        <el-pagination
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="pageData.page"
          :page-sizes="[20, 40, 60, 80, 100]"
          :page-size="pageData.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 移动端（你可以后续再补） -->
    <div class="mobile" v-else>
      <div class="mobile_full">移动端页面待开发</div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal"; // 这里改成你的积分相关API文件
import moment from "moment";
import { redirectRoute } from "@/utils/tools";
export default {
  name: "scoreRecord",
  components: {},
  data() {
    return {
      query: {
        startDate: "",
        endDate: "",
        sourceType: "",
        departmentId: "",
        rankId: "",
        phone: "",
        empNo: "",
      },
      pageData: {
        page: 1,
        pageSize: 20,
      },
      total: 0,
      tableData: [],
      tableLoading: false,
      windowHeight: 350,
      mobileFlag: false,
      // 下拉选项
      optionsSourceType: [],
      optionsDepartment: [], // 部门下拉选项，后续接口获取
      optionsRank: [], // 职级下拉选项，后续接口获取
      defaultProps1: {
        multiple: false,
        children: "child",
        value: "id",
        label: "departmentName",
        emitPath: false,
        // checkStrictly: true,
      },
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.queryData();
    this.getDepartmentList();
    this.getRankList();
    this.redirect();
    this.getSourceList();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    // 积分来源
    async getSourceList() {
      try {
        const res = await api.getPointSet({ page: 1, pageSize: 999 });
        this.optionsSourceType = res.data?.list || [];
      } catch (err) {
        this.$message.error("获取积分来源失败");
      }
    },
    // 判断是否是移动端
    redirect() {
      const { type } = this.$route.query;
      const flag = redirectRoute();
      if (type && !flag) {
        this.mobileFlag = false;
      } else {
        this.mobileFlag = true;
      }
    },
    handleResize() {
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 320;
      });
    },
    // 查询列表
    queryData() {
      const json = {
        ...this.pageData,
        empNo: this.query.empNo,
        phone: this.query.phone,
        orgId: this.query.orgId,
        empRank: this.query.empRank,
        sourceTypeId: this.query.sourceTypeId,
        startTime: this.query.startDate
          ? moment(this.query.startDate).format("YYYY-MM-DD 00:00:00")
          : "",
        endTime: this.query.endDate
          ? moment(this.query.endDate).format("YYYY-MM-DD 23:59:59")
          : "",
      };
      this.tableLoading = false;
      // 这里改成你实际的积分记录列表接口
      api
        .scoreRecordListApi(json)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.list || [];
            this.total = res.data.total || 0;
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    // 分页大小改变
    handleSizeChange1(val) {
      this.pageData.pageSize = val;
      this.queryData();
    },
    // 当前页改变
    handleCurrentChange1(val) {
      this.pageData.page = val;
      this.queryData();
    },
    // 导出
    exportRecord() {
      const json = {
        empNo: this.query.empNo,
        phone: this.query.phone,
        departmentId: this.query.departmentId,
        rankId: this.query.rankId,
        sourceType: this.query.sourceTypeId,
        startTime: this.query.startDate
          ? moment(this.query.startDate).format("YYYY-MM-DD 00:00:00")
          : "",
        endTime: this.query.endDate
          ? moment(this.query.endDate).format("YYYY-MM-DD 23:59:59")
          : "",
      };
      // 这里改成你实际的导出接口
      api.scoreRecordExport(json).then((res) => {
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", `积分变动记录.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
    },
    // 获取部门列表
    getDepartmentList() {
      api.findListByName().then((data) => {
        if (data.code == 200) {
          this.optionsDepartment = data.data || [];
        }
      });
    },
    // 获取职级列表（后续根据实际接口实现）
    getRankList() {
      api.getPositionLevel({ type: "EmpRank" }).then((res) => {
        if (res.code == 200) {
          this.optionsRank = res.data || [];
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.content1 {
  background-color: #f2fcf9;

  .mobile {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background: #f0f2f5;
    display: flex;
    justify-content: center;
    font-size: 11px * $zoom;
    @media screen and (max-width: 600px) {
      .mobile_full {
        width: 100%;
        background-size: 100% 100%;
      }
    }
    @media screen and (min-width: 600px) {
      .mobile_full {
        width: 276px * $zoom;
        background-size: 100% 100%;
      }
    }
  }

.filter-bar {
  padding: 16px;
  background: #fafbfc;
  border-radius: 8px;
  margin-bottom: 20px;

}
  .table_con {
    background-color: #fff;
    border: 1px solid #e2e6e5;
    padding: 20px 20px 40px;
    margin: 0 40px;
    border-radius: 5px;
  }
  .pagination_con {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    padding-right: 40px;
  }
}
</style>
